import { BASE_URL } from './Config.js';

export class BCFService {

  // 1. Récupérer tous les BCF (pour la page Liste)
  findAll = async () => {
    const token = localStorage.getItem('accessToken');
    if (!token) throw new Error('Token manquant');

    const response = await fetch(`${BASE_URL}/bcf/all`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error(`Erreur HTTP: ${response.status}`);
    return await response.json();
  };

  // 2. Récupérer un BCF spécifique par son ID (pour la page Édition)
  findById = async (id) => {
    const token = localStorage.getItem('accessToken');
    if (!token) throw new Error('Token manquant');

    const response = await fetch(`${BASE_URL}/bcf/${id}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error(`Erreur HTTP: ${response.status}`);
    return await response.json();
  };

  // 3. Créer un nouveau BCF
  create = async (data) => {
    const token = localStorage.getItem('accessToken');
    if (!token) throw new Error('Token manquant');

    const response = await fetch(`${BASE_URL}/bcf/create`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
      body: JSON.stringify(data)
    });
    if (!response.ok) throw new Error(`Erreur HTTP: ${response.status}`);
    return await response.json();
  };

  // 4. Mettre à jour un BCF existant (Save)
  update = async (id, data) => {
    const token = localStorage.getItem('accessToken');
    if (!token) throw new Error('Token manquant');

    const response = await fetch(`${BASE_URL}/bcf/update/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
      body: JSON.stringify(data)
    });
    if (!response.ok) throw new Error(`Erreur HTTP: ${response.status}`);
    return await response.json();
  };

  // 5. Ajouter des lignes existantes (orphelines) à un BCF
  // Correspond à: @PostMapping("/{id}/add-lines") avec List<Long> bcfLineIds
  addLines = async (bcfId, bcfLineIds) => {
    const token = localStorage.getItem('accessToken');
    if (!token) throw new Error('Token manquant');

    const response = await fetch(`${BASE_URL}/bcf/${bcfId}/add-lines`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
      body: JSON.stringify(bcfLineIds) // Envoie directement le tableau d'IDs [1, 2, 3]
    });
    if (!response.ok) throw new Error(`Erreur HTTP: ${response.status}`);
    return await response.json();
  };

  // 🟢 Détacher une ligne (la rendre orpheline au lieu de la supprimer)
  detachLine = async (bcfId, lineId) => {
    const token = localStorage.getItem('accessToken');
    if (!token) throw new Error('Token manquant');
    
    const response = await fetch(`${BASE_URL}/bcf/${bcfId}/detach-line/${lineId}`, {
      method: 'POST', 
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error(`Erreur HTTP: ${response.status}`);
    return await response.text();
  };

  // 7. Valider / Clôturer le BCF (le rendre immuable)
  // Correspond à: @PostMapping("/close/{id}")
  close = async (bcfId) => {
    const token = localStorage.getItem('accessToken');
    if (!token) throw new Error('Token manquant');

    const response = await fetch(`${BASE_URL}/bcf/close/${bcfId}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error(`Erreur HTTP: ${response.status}`);
    return await response.json();
  };

  // 8. Récupérer les lignes orphelines (Staging Area)
  // Correspond à: @GetMapping("/lines/orphaned")
  // Utile pour la fonctionnalité "Prélever sur achat clôturé"
  getOrphanedLines = async () => {
    const token = localStorage.getItem('accessToken');
    if (!token) throw new Error('Token manquant');

    const response = await fetch(`${BASE_URL}/bcf/lines/orphaned`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error(`Erreur HTTP: ${response.status}`);
    return await response.json();
  };

  downloadPdf = async (id) => {
  const token = localStorage.getItem('accessToken');
  if (!token) throw new Error('Token manquant');
  const response = await fetch(`${BASE_URL}/pdf/download-pdf-bcf/${id}`, {   // adjust the controller base path
    headers: { 'Authorization': `Bearer ${token}` }
  });
  if (!response.ok) throw new Error(`Erreur HTTP: ${response.status}`);
  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `bcf_${id}.pdf`;
  a.click();
  window.URL.revokeObjectURL(url);
  };
}